export const saveFileToDevice = async (
  fileUrl: string,
  fileName: string,
): Promise<boolean> => {
  try {
    const response = await fetch(fileUrl)
    if (!response.ok) return false

    const fileBlob = await response.blob()
    const downloadLink = document.createElement('a')
    downloadLink.href = URL.createObjectURL(fileBlob)
    downloadLink.download = fileName
    document.body.appendChild(downloadLink)
    downloadLink.click()
    downloadLink.remove()

    return true
  } catch {
    return false
  }
}
